<script>
  import solicitacaoCursoEventoServicoServico from '../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import Barcode from '@xkeshi/vue-barcode';
  import converterNumero from '~js/converter-moeda';
  import converterMoeda from '~js/converter-moeda';

  export default {
    components: { Cabecalho, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      classeOpcoes(valor) {
        return valor ? 'fa-check-square-o' : 'fa-square-o';
      },
      carregar: function(id) {
        this.carregando = true;

        solicitacaoCursoEventoServicoServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      textotipoPergunta(questionario) {
        if (questionario.tipoCampoResposta)
          return 'Campo Resposta';

        if (questionario.tipoCampoSimNao)
          return 'Campo Sim/Não';

        if (questionario.tipoCampoSelecao)
          return 'Campo Seleção';
      },   
      textoItens(questionario) {
        if (questionario.tipoCampoSelecaoItens)
            return questionario.tipoCampoSelecaoItens.replace(/\r\n/g, '</br>').replace(/\n/g, '</br>');

        return '';
      },
        valorCategoria(faixa) {
            if (faixa.valor == 0)
                return 'isento'

            if (!faixa.valor)
                return '---'            

            return faixa.valor;
        },
        retornaStringBooleano(valorBooleano) {
            if (typeof valorBooleano === "string") {
                if (valorBooleano === 'true' || valorBooleano === '1')
                    return 'Sim';

                return 'Não';
            }

            return valorBooleano ? 'Sim' : 'Não';
        }
    },
    computed: {  
      labelmensagemFinalSalvar() {
        var msg = 'Mensagem de conclusão ao salvar uma ';

        if (this.solicitacao.tipoSolicitacao == 4)
          msg += ' doação.';
        else
          msg += ' inscrição';

        return msg;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      },
      retornaValorSolicitacao() {
        let total = 0;
        
        total += this.solicitacao.projetos.reduce((somatorio, rateio) => {
          return somatorio + converterNumero.paraDolar(rateio.percentual);
        }, 0);

        return total;
      },
      tipoSolicitacao() {
        switch (this.solicitacao.tipoSolicitacao) {
          case "1":
            return "Curso"
            break;
          case "2":
            return "Evento"
            break;
          case "3":
            return "Serviço"
            break;
          case "4":
            return "Doação"
            break;
          default:
            return ""
        }
      },
      cursoEvento() {
        switch (this.solicitacao.tipoSolicitacao) {
          case "1":
          case "2":
            return true;
            break;
          default:
            return false
        }
      },
      doacao() {
        return (this.solicitacao.tipoSolicitacao === "4");
      },
      labelDescricao() {
        if (parseInt(this.solicitacao.tipoSolicitacao) == 1) {
          return 'Nome do curso';
        }
        if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
          return 'Nome do evento';
        }
        return 'Descrição';
      },
      labelDuracao() {
        if (parseInt(this.solicitacao.tipoSolicitacao) == 1) {
          return 'Duração do curso';
        }
        if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
          return 'Dia e horário do evento';
        }
        return 'Duração';
      },
      labelMetodologia() {
        if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
          return 'Programação';
        }
        return 'Metodologia';
      }
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de ' + this.configuracao.nomeModuloSolCursoEventoServico + ' - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-curso-evento-servico';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<style scoped>
    .infoSol {
        font-size: 1.20em;
        color: #1d9d74;
        margin-right: 3px;
    }
</style>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">

              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                  <cabecalho :titulo="'Solicitação de ' + configuracao.nomeModuloSolCursoEventoServico"></cabecalho>

                  <h3 class="m-t-none m-b">Dados da solicitação</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="row">
                      <dl class="col-xs-3">
                          <dt>Número</dt>
                          <dd>{{ solicitacao.idSolicitacaoCursoEventoServico || '---' }}</dd>
                      </dl>
                      <dl class="col-xs-3">
                          <dt>Data da solicitação</dt>
                          <dd>
                              {{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}
                          </dd>
                      </dl>
                      <dl class="col-xs-3">
                          <dt>Solicitante</dt>
                          <dd>{{ solicitacao.solicitante ? solicitacao.solicitante.nomePessoaFisicaJuridica : '---' }}</dd>
                      </dl>
                  </div>

                  <div class="row">
                      <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                          <dt>Data de liberação do coordenador</dt>
                          <dd>{{ dataLiberacaoCoordenador }}</dd>
                      </dl>
                      <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                          <dt>Liberado por</dt>
                          <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                      </dl>
                  </div>

                  <div class="row">

                      <dl class="col-xs-8">
                          <dt>{{ labelDescricao }}</dt>
                          <dd>{{ solicitacao.descricao }}</dd>
                      </dl>

                      <dl class="col-xs-4">
                          <dt>Tipo solicitação</dt>
                          <dd>{{ tipoSolicitacao }}</dd>
                      </dl>

                  </div>

                  <div class="row">

                      <dl class="col-xs-12">
                          <dt>Resumo</dt>
                          <dd>{{ solicitacao.resumo }}</dd>
                      </dl>

                  </div>

                  <div class="row">

                      <dl class="col-xs-6">
                          <dt>Instituição Responsável</dt>
                          <dd>{{ solicitacao.instituicao }}</dd>
                      </dl>

                      <dl class="col-xs-3">
                          <dt>Unidade</dt>
                          <dd>{{ solicitacao.unidade }}</dd>
                      </dl>

                      <dl class="col-xs-3">
                          <dt>Departamento</dt>
                          <dd>{{ solicitacao.departamento }}</dd>
                      </dl>

                  </div>

                  <h3 class="m-t-none m-b" v-if="doacao">Doação</h3>

                  <div class="hr-line-dashed margin-top-5" v-if="doacao"></div>

                  <div class="row" v-if="doacao">

                      <dl class="col-xs-2">
                          <dt>Valor mínimo</dt>
                          <dd>{{ solicitacao.solicitacaoDoacao[0].valorMinimo }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Valor máximo</dt>
                          <dd>{{ solicitacao.solicitacaoDoacao[0].valorMaximo }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Valor padrão 1</dt>
                          <dd>{{ solicitacao.solicitacaoDoacao[0].valorPadrao1 }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Valor padrão 2</dt>
                          <dd>{{ solicitacao.solicitacaoDoacao[0].valorPadrao2 }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Valor padrão 3</dt>
                          <dd>{{ solicitacao.solicitacaoDoacao[0].valorPadrao3 }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Valor padrão 4</dt>
                          <dd>{{ solicitacao.solicitacaoDoacao[0].valorPadrao4 }}</dd>
                      </dl>

                  </div>

                  <h3 class="m-t-none m-b" v-if="doacao">Dados adicionais</h3>

                  <div class="hr-line-dashed margin-top-5" v-if="doacao"></div>

                  <div class="row" v-if="doacao && solicitacao.solicitacaoDoacao[0].descricaoDoacao">

                      <dl class="col-xs-12">
                          <dt>Informações doação</dt>
                          <dd>{{ solicitacao.solicitacaoDoacao[0].descricaoDoacao }}</dd>
                      </dl>

                  </div>

                  <h3 class="m-t-none m-b" v-if="cursoEvento">Curso\Evento</h3>

                  <div class="hr-line-dashed margin-top-5" v-if="cursoEvento"></div>

                  <div class="row" v-if="cursoEvento">

                      <dl class="col-xs-2">
                          <dt>Nº de alunos máximo</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].alunosMaximo }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Nº de alunos mínimo</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].alunosMinimo }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Data início</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].dataInicio }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Data fim</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].dataFim }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Início inscrição</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].dataInicioInscricao }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Limite inscrição</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].dataLimiteInscricao }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento">

                      <dl class="col-xs-2">
                          <dt>Venc. 1ª parcela</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].dataVencimentoParcela }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Nº parcelas</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].parcelas }}</dd>
                      </dl>

                      <dl class="col-xs-2">
                          <dt>Valor parcela</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].valorParcela }}</dd>
                      </dl>
                  </div>

                  <h3 class="m-t-none m-b" v-if="cursoEvento">Dados adicionais</h3>

                  <div class="hr-line-dashed margin-top-5" v-if="cursoEvento"></div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].informacoes">

                      <dl class="col-xs-12">
                          <dt>Informações</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].informacoes }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].observacoes">

                      <dl class="col-xs-12">
                          <dt>Observações</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].observacoes }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].justificativa">

                      <dl class="col-xs-12">
                          <dt>Justificativa</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].justificativa }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].objetivos">

                      <dl class="col-xs-12">
                          <dt>Objetivos</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].objetivos }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].metodologia">

                      <dl class="col-xs-12">
                          <dt>{{ labelMetodologia }}</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].metodologia }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].infraestrutura">

                      <dl class="col-xs-12">
                          <dt>Infraestrutura</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].infraestrutura }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].ementaDisciplina">

                      <dl class="col-xs-12">
                          <dt>Ementa\Disciplinas</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].ementaDisciplina }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].preRequisito">

                      <dl class="col-xs-12">
                          <dt>Pré-requisito</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].preRequisito }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].publicoAlvo">

                      <dl class="col-xs-12">
                          <dt>Público-alvo</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].publicoAlvo }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].formaPagamento">

                      <dl class="col-xs-12">
                          <dt>Formas de pagamento</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].formaPagamento }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].devolucaoInscricao">

                      <dl class="col-xs-12">
                          <dt>Devolução de inscrição</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].devolucaoInscricao }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].local">

                      <dl class="col-xs-12">
                          <dt>Local</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].local }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].duracao">

                      <dl class="col-xs-12">
                          <dt>{{ labelDuracao }}</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].duracao }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].areaConhecimento">

                      <dl class="col-xs-12">
                          <dt>Área do conhecimento</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].areaConhecimento }}</dd>
                      </dl>

                  </div>

                  <div class="row" v-if="cursoEvento && solicitacao.solicitacaoCursoEventos[0].outrasInformacoes">

                      <dl class="col-xs-12">
                          <dt>Outras informações</dt>
                          <dd>{{ solicitacao.solicitacaoCursoEventos[0].outrasInformacoes }}</dd>
                      </dl>

                  </div>

                  <h3 class="m-t-none m-b" v-if="cursoEvento">Valores e categorias para inscrição</h3>

                  <div class="hr-line-dashed margin-top-5" v-if="cursoEvento"></div>

                  <div class="table-responsive" v-if="cursoEvento">
                      <table class="table table-bordered table-column-action">
                          <thead>
                              <tr>
                                  <th style="text-align: left;">Categorias</th>
                                  <th style="width:90px;">Valor (R$)</th>
                                  <th v-if="configuracao.usarArquivosInscricao" style="width:90px;">Anexar arquivo</th>
                                  <th v-if="configuracao.usarArquivosInscricao" style="width:90px;">Arquivo obrigatório</th>
                                  <th v-if="configuracao.usarArquivosInscricao" style="width:90px;">Quantidade mínima arquivos</th>
                                  <th v-if="configuracao.usarArquivosInscricao" style="width:90px;">Quantidade máxima arquivos</th>
                                  <th v-if="configuracao.usarArquivosInscricao" style="text-align: left;">Mensagem anexo</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(faixaValor, index) in solicitacao.solicitacaoCursoEventos[0].faixaValores">
                                  <td style="text-align: left;">{{ faixaValor.descricao || '---' }}</td>
                                  <td style="width:90px;">{{  valorCategoria(faixaValor) }}</td>
                                  <td v-if="configuracao.usarArquivosInscricao" style="width:90px;">
                                      {{retornaStringBooleano(faixaValor.utilizarArquivo)}}
                                  </td>
                                  <td v-if="configuracao.usarArquivosInscricao" style="width:90px;">
                                      {{retornaStringBooleano(faixaValor.anexoObrigatorio)}}
                                  </td>
                                  <td v-if="configuracao.usarArquivosInscricao" style="width:90px;">{{ faixaValor.quantidadeMinimaArquivos || '---' }}</td>
                                  <td v-if="configuracao.usarArquivosInscricao" style="width:90px;">{{ faixaValor.quantidadeMaximaArquivos || '---' }}</td>
                                  <td v-if="configuracao.usarArquivosInscricao" style="text-align: left;">{{ faixaValor.textoAnexo || '---' }}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>

                  <h3 class="m-t-none m-b" v-if="solicitacao.solicitacaoCursoEventoForms.length > 0">Questionário</h3>

                  <div class="hr-line-dashed margin-top-5" v-if="solicitacao.solicitacaoCursoEventoForms.length > 0"></div>

                  <div class="table-responsive" v-if="solicitacao.solicitacaoCursoEventoForms.length > 0">
                      <table class="table table-bordered table-column-code table-column-action">
                          <thead>
                              <tr>
                                  <th></th>
                                  <th>Pergunta</th>
                                  <th>Tipo de pergunta</th>
                                  <th>Obrigatória</th>
                                  <th>Itens da seleção</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(questionario, index) in solicitacao.solicitacaoCursoEventoForms">
                                  <td></td>
                                  <td>{{ questionario.pergunta }}</td>
                                  <td>{{ textotipoPergunta(questionario) }}</td>
                                  <td>{{ questionario.obrigatorio == '1' ? 'Sim' : 'Não' }}</td>
                                  <td><span v-if="questionario.tipoCampoSelecao" v-html="textoItens(questionario)" /></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>

                  <h3 class="m-t-none m-b">Configurações</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="row">
                      <dl class="col-xs-2">
                          <dt>Cadastro completo <i class="fa fa-info-circle infoSol" v-tooltip="'Se SIM, será necessário informar o endereço no cadastro das inscrições\\doações.'"></i></dt>
                          <dd>{{retornaStringBooleano(solicitacao.cadastroCompleto)}}</dd>
                      </dl>
                  </div>

                  <div class="row">
                      <dl class="col-xs-6">
                          <dt>Site</dt>
                          <dd>{{ solicitacao.siteCursoEvento || '---' }}</dd>
                      </dl>

                      <dl class="col-xs-6">
                          <dt>URL Instagram</dt>
                          <dd>{{ solicitacao.instagramCursoEventoDoacao || '---' }}</dd>
                      </dl>
                  </div>

                  <div class="row">
                      <dl class="col-xs-12">
                          <dt>{{labelmensagemFinalSalvar}}</dt>
                          <dd>{{ solicitacao.mensagemFinalSalvar || '---' }}</dd>
                      </dl>
                  </div>

                  <h3 class="m-t-none m-b">Internacionalização</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="row">
                      <dl class="col-xs-2">
                          <dt>Permitir estrangeiros <i class="fa fa-info-circle infoSol" v-tooltip="'Se SIM, será permitido inscrições\\doações de pessoas estrangeiras sem CPF.'"></i></dt>
                          <dd>{{retornaStringBooleano(solicitacao.permitirEstrangeiro)}}</dd>
                      </dl>

                      <dl class="col-sm-2" v-if="solicitacao.permitirEstrangeiro" style="margin-top: 5px;">
                          <dt>
                              <i class="fa" :class="classeOpcoes(solicitacao.traduzirIngles)"></i> Traduzir para Inglês <br>
                          </dt>
                      </dl>

                      <dl class="col-sm-2" v-if="solicitacao.permitirEstrangeiro" style="margin-top: 5px;">
                          <dt>
                              <i class="fa" :class="classeOpcoes(solicitacao.traduzirEspanhol)"></i> Traduzir para Espanhol <br>
                          </dt>
                      </dl>

                      <dl class="col-sm-2" v-if="solicitacao.permitirEstrangeiro" style="margin-top: 5px;">
                          <dt>
                              <i class="fa" :class="classeOpcoes(solicitacao.traduzirFrances)"></i> Traduzir para Francês <br>
                          </dt>
                      </dl>

                      <dl class="col-sm-2" v-if="solicitacao.permitirEstrangeiro" style="margin-top: 5px;">
                          <dt>
                              <i class="fa" :class="classeOpcoes(solicitacao.traduzirItaliano)"></i> Traduzir para Italiano <br>
                          </dt>
                      </dl>
                  </div>

                  <h3 class="m-t-none m-b">Projetos</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="bs-callout bs-callout-info no-margin-top" v-for="(rateio, index) in solicitacao.projetos">
                      <div class="row">
                          <dl :class="[rateio.projetoMetaEtapa != null ? 'col-xs-4' : 'col-xs-6']">
                              <dt>Projeto</dt>
                              <dd>{{ rateio.projeto ? rateio.projeto.nomeProjeto : ''}}</dd>
                          </dl>

                          <dl class="col-xs-2">
                              <dt>Percentual (%)</dt>
                              <dd>{{ rateio.percentual || '---' }}</dd>
                          </dl>
                      </div>
                  </div>

                  <div class="bs-callout bs-callout-primary" v-if="configuracao.utilizarValorEstimado">
                      <h4>Percentual total: {{ retornaValorSolicitacao | formatarNumero }} %</h4>
                  </div>

                  <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solCursoEventoServicoMsgConfirmacao"></div>

                  <div class="row" v-if="this.configuracao.solCursoEventoServicoMsgConfirmacao">
                      <div class="col-md-12">
                          <p><i>{{this.configuracao.solCursoEventoServicoMsgConfirmacao}}</i></p>
                      </div>
                  </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/SolicitacaoCursoEventoServicoRelatorio.vue